/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsExclamation: {
  name: 'exclamation';
  data: string;
} = {
  name: 'exclamation',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1.5a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0v-10ZM8 15a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
